<template>
  <div class="text-center my-4">
    <p v-if="isRegistered">
      Your new project is ready!
    </p>
    <p v-else>
      Congrats, you've generated your first project using API Bakery!
      <br> &nbsp; <br>
      You can examine the generated code in the preview on the right.
      To save or download the project, sign up for a free account.
    </p>
    <p>
      <b-button variant="primary" href="/projects/" v-if="isRegistered">
        Save and download project
      </b-button>
      <b-button variant="primary" href="/account/signup/" v-else>
        Sign up and download project
      </b-button>
    </p>
  </div>
</template>

<script>
import { isRegisteredUser } from '../utils/config';

export default {
  name: 'FinishDemo',

  mounted () {
    localStorage.DEMO_PROJECT = JSON.stringify(this.$store.state.recipe)
  },

  computed: {
    isRegistered () {
      return isRegisteredUser
    }
  }

}
</script>
